import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
//i18n
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Carregando from "../../../components/Carregando"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ModalCadastroGrupo from "../../../components/modals/grupo/ModalCadastroGrupo"
import ModalEdicaoGrupo from "../../../components/modals/grupo/ModalEdicaoGrupo"
import PermissaoContext from "../../../contexts/PermissaoContext"
import { deleteGrupo, getGrupos } from "../../../services/grupos"
import { getUsers } from "../../../store/contacts/actions"
import GruposListaColunas from "./GruposListaColunas"









const GruposLista = props => {
  function translate (text) {
    return props.t(text)
  }

  const { users, onGetUsers } = props
  const [list, setList] = useState([])
  const [listView, setListView] = useState([])
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: list.length,
    custom: true
  })
  const { SearchBar } = Search

  const [page, setPage] = useState(1)
  const [searchText, setSearchText] = useState("")

  const [modalCadastroOpened, setModalCadastroOpened] = useState(false)
  const [modalEdicaoOpened, setModalEdicaoOpened] = useState(null)

  const [sweetAlert, setSweetAlert] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtnBsStyle: "success",
    onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) }
  })

  const { permissoes, isLoadingPermissoes } = useContext(PermissaoContext)

  useEffect(() => {
    buscarGrupos()
  }, [])

  useEffect(() => {

  }, [list])

  useEffect(() => {
    if (!isEmpty(users)) {
      setList(users)
    }
  }, [users])

  const buscarGrupos = async () => {
    try {
      const grupos = await getGrupos()

      setList(grupos)
      setListView(grupos)
    } catch (error) {
    }
  }

  const removerGrupo = async (grupo) => {
    try {
      console.log("removerGrupo", grupo)
      setSweetAlert({
        ...sweetAlert,
        show: true,
        title: translate("Atenção!"),
        text: `${translate("Tem certeza que deseja excluir o grupo")} ${grupo.nome}?`,
        showCancel: true,
        cancelBtnBsText: translate("Não"),
        cancelBtnBsStyle: "danger",
        warning: true,
        onCancel: () => { setSweetAlert({ ...sweetAlert, show: false }) },
        onConfirm: async () => {
          setSweetAlert({ ...sweetAlert, showCancel: false, showConfirm: false, title: translate("Aguarde"), text: translate("Estamos removendo o grupo") })
          try {
            let retorno = await deleteGrupo(grupo.id)
            setSweetAlert({ ...sweetAlert, showConfirm: true, info: false, success: true, title: translate("Sucesso"), text: retorno || translate("Grupo removido com sucesso!"), onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) } })
            handleRefresh(grupo, "remove")
          } catch (error) {
            setSweetAlert({ ...sweetAlert, showConfirm: true, info: false, error: true, title: translate("Ooops"), text: error.message || translate("Ocorreu um erro."), onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) } })
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleRefresh = async (grupo, action = "add") => {
    console.log("{ handleRefresh }", action, list, grupo)
    if (action == "add") {
      let newArray = [...list, grupo]
      setList(newArray)
      setPageOptions({ ...pageOptions, totalSize: list.length + 1 })
      handleTableChange(null, { page, searchText }, newArray)
    } else if (action == "edit") {
      let newArray = [...list]
      for (let i = 0; i < newArray.length; i++) {
        const el = newArray[i]
        if (el.id == grupo.id) {
          newArray[i] = grupo
          break
        }
      }
      handleTableChange(null, { page, searchText }, newArray)
    } else if (action == "remove") {
      let newArray = list.filter(user => user.id != grupo.id)
      setList(newArray)
      setPageOptions({ ...pageOptions, totalSize: newArray.length - 1 })
      handleTableChange(null, { page, searchText }, newArray)
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (type, { page, searchText }, data = null) => {
    const dados = data || list
    console.log("{ handleTableChange }", page, searchText, dados)
    setPage(page)
    setSearchText(searchText)

    let inicio = pageOptions.sizePerPage * page - pageOptions.sizePerPage
    let fim = pageOptions.sizePerPage * page
    if (fim > dados.length) fim = dados.length

    setListView(
      dados.slice(inicio, fim).filter(user =>
        Object.keys(user).some(
          key =>
            typeof user[key] === "string" &&
            user[key].toLowerCase().includes(searchText.toLowerCase())
        )
      )
    )
  }

  var selectRowProp = {
    mode: "checkbox",
    clickToSelect: false,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title={translate("Grupos")} breadcrumbItem={translate("Lista de Grupos")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoadingPermissoes ? <Carregando /> :
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={listView || []}
                          columns={GruposListaColunas(removerGrupo, setModalEdicaoOpened, permissoes, translate)}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="row mb-2">
                                <Col md={6}>
                                  {permissoes.grupos_gerenciamento && <div className="mb-3">
                                    <Link to="#" className="btn btn-success waves-effect waves-light" onClick={() => setModalCadastroOpened(true)}><i className="mdi mdi-plus me-2"></i>{translate("Novo")}</Link>
                                  </div>}
                                </Col>

                                <Col md={6}>
                                  <div className="form-inline float-md-end mb-3">
                                    <div className="search-box ms-2">
                                      <div className="position-relative">
                                        <SearchBar {...toolkitProps.searchProps} />
                                        <i className="mdi mdi-magnify search-icon"></i>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive mb-4">
                                    <BootstrapTable
                                      selectRow={selectRowProp}
                                      responsive
                                      remote
                                      bordered={false}
                                      striped={false}
                                      classes={"table table-centered table-nowrap mb-0"}
                                      {...toolkitProps.baseProps}
                                      onTableChange={handleTableChange}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <div className="float-sm-end">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalCadastroGrupo opened={modalCadastroOpened} setOpened={setModalCadastroOpened} refresh={handleRefresh} />
      <ModalEdicaoGrupo opened={modalEdicaoOpened} setOpened={setModalEdicaoOpened} refresh={handleRefresh} values={modalEdicaoOpened} />

      {sweetAlert.show && <SweetAlert {...sweetAlert}>{sweetAlert.text}</SweetAlert>}
    </React.Fragment>
  )
}

GruposLista.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
}

const mapStateToProps = ({ contacts }) => ({
  users: contacts.users,
})

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(getUsers()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(GruposLista)))
